import React from 'react';

import StatsWrapper from 'components/Stats/StatsWrapper';
import NavPills from "components/NavPills/NavPills.jsx";
import VolumeByReferenceChart from './VolumesTabs/VolumeByReferenceChart';
import VolumeByReferenceTable from './VolumesTabs/VolumeByReferenceTable';
import VolumeByServiceChart from './VolumesTabs/VolumeByServiceChart';
import VolumeByServiceTable from './VolumesTabs/VolumeByServiceTable';

export default class VolumesTab extends React.Component {
    render() {
        const id = this.props.customer_id + "-" + this.props.product_id;

        return (
            <NavPills
                swipeableSlideStyles={{ padding: 20 }}
                color="info"
                tabs={[
                    {
                        tabButton: "Volumes by Reference",
                        tabContent: (
                            <StatsWrapper id={id} snackbar={this.props.snackbar} name="volumes" post params={{ customer_id: this.props.customer_id, product_id: this.props.product_id }}>
                                <VolumeByReferenceChart />
                                <VolumeByReferenceTable />
                            </StatsWrapper>
                        )
                    },
                    {
                        tabButton: "Volumes by Service",
                        tabContent: (
                            <StatsWrapper id={id} snackbar={this.props.snackbar} name="volumesByService" post params={{ customer_id: this.props.customer_id, product_id: this.props.product_id }}>
                                <VolumeByServiceChart />
                                <VolumeByServiceTable />
                            </StatsWrapper>
                        )
                    }
                ]}
            />
        );
    }
}